import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AllMessengersService } from '../../../../page-start/all-messengers.service';
import { AuthService } from '../../../../../modules/auth/services/auth.service';
import { InterfaceService } from '../../../../../services/interface.service';
import { ModalService } from '../../../../../services/modal.service';
import { AllService } from '../../../../../services/all.service';
import { SenderService } from '../../../../../services/sender.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { finalize, Subject } from 'rxjs';
import { NotifierWrapService } from '../../../../../services/notifier-wrap.service';

@Component({
  selector: 'app-sender-forgot',
  templateUrl: './sender-forgot.component.html',
  styleUrls: ['./sender-forgot.component.scss']
})
export class SenderForgotComponent implements OnInit {

  isLoading$: Subject<boolean> = new Subject();
  lastError: any;
  Form: UntypedFormGroup;
  constructor(
    public notifierWrapService: NotifierWrapService,
    public allMessengersService: AllMessengersService,
    public authService: AuthService,
    public interfaceService: InterfaceService,
    public modalService: ModalService,
    public allService: AllService,
    public senderService: SenderService,
    public cd: ChangeDetectorRef,
    public bsModalRef: BsModalRef
  ) {
  }

  ngOnInit(): void {
    this.Form = new UntypedFormGroup({
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
    });
  }
  onSubmit() {
    delete this.lastError;
    this.isLoading$.next(true);
    const controls = this.Form.controls;
    const values = this.Form.value;

    // Проверяем форму на валидность */
    if (this.Form.invalid) {
      // Если форма не валидна, помечаем все контролы как touched **/
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }
    this.senderService.senderForgot(values).pipe(finalize(() => {
      this.isLoading$.next(false);
      this.cd.detectChanges();
    })).subscribe(
      (result: any) => {
        this.notifierWrapService.notify('success', 'Пароль выслан на указанную почту.');
        this.authService.mode$.next('Авторизация');
        this.Form.reset();
      },
      (error) => {
        this.isLoading$.next(false);
        this.interfaceService.errorHandling(error);
      }
    );
  }
}
